import { Box, SimpleGrid, Text } from "@chakra-ui/react";
import { MotionDetectDevice } from "../components/MotionDetectDevice.jsx";
import { useLocation } from "react-router-dom";
import React, { useState, useContext, useEffect } from "react";
import { SignalRContext } from "./SignalRContext";

export const MotionDetectPage = () => {
  const { message } = useContext(SignalRContext);
  const [devices, setDevices] = useState([]);
  const location = useLocation();

  let deviceList = [];
  let motionDetected = [];

  if (message.flag === false) {
    motionDetected = location.state;
  } else {
    deviceList = devices;
    motionDetected = deviceList.filter((e) => {
      if (e.deviceType === 1 && e.status === "1") {
        return true;
      } else {
        return false;
      }
    });
  }

  useEffect(() => {
    // Trigger the loader to fetch data
    if (message.flag === true) {
      //     console.log("flag = " + message.flag);
      setDevices(message.devices);
    }
    //  console.log("SignalR message received in Child2:", message);
    // Fetch new data or update the content here
  }, [message]);

  return (
    <Box mt="20px" ml="20px" mr="20px">
      <Text mb="20px" ml="5px" fontSize="sm"></Text>
      <SimpleGrid columns={[1, 1, 2, 2, 3, 3, 4]} spacing="10px">
        {motionDetected.map((e) => (
          <MotionDetectDevice key={e.deviceId} device={e} />
        ))}
      </SimpleGrid>
    </Box>
  );
};
